import { AutomationEventTypes } from "../AutomationModuleTypes";
import _ from "lodash";

const vt = {
    STRING: "string",
    NUMBER: "number",
    BOOLEAN: "boolean",
    DATE: "date",
    DATETIME: "datetime",
    TIME: "time",
    ENUM: "enum",
    ARRAY: "array",
    ARRAY_STRING: "array_string",
    OBJECT: "object",
};

const contexts = {
    EVENT: "event",
    SYSTEM: "system",
};

const ga = (
    context,
    value,
    label,
    valueType = "string",
    controlType = "input",
    subAttributes = [],
    defaultFilterValue = undefined,
    defaultOperator = undefined,
    availableOperators = undefined,
    options = undefined
) => {
    return {
        context,
        value,
        label,
        defaultOperator: defaultOperator || "equal",
        defaultFilterValue,
        availableOperators: availableOperators || ["equal", "not_equal"],
        controlType,
        options,
        subAttributes,
        valueType,
    };
};

class VoiceAgentModuleAttributeFactory {
    constructor(parent) {
        this.parent = parent;
    }

    generate() {
        return _.concat(
            this.callStarted(),
            this.callEnded(),
            this.callAnalyzed()
        );
    }

    callStarted() {
        const e = AutomationEventTypes.VOICE_AGENT.CALL_STARTED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Voice Agent Call Started", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.callId`, "Call ID", vt.STRING),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
            ]),
        ];
    }

    callEnded() {
        const e = AutomationEventTypes.VOICE_AGENT.CALL_ENDED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Voice Agent Call Ended", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.callId`, "Call ID", vt.STRING),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
            ]),
        ];
    }

    callAnalyzed() {
        const e = AutomationEventTypes.VOICE_AGENT.CALL_ANALYZED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Voice Agent Call Analyzed", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.callId`, "Call ID", vt.STRING),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
            ]),
        ];
    }
}

export default VoiceAgentModuleAttributeFactory; 